window.openRecept = () => {
    document.getElementById('login_id').value='recept'
    document.getElementById('password').value='22222222'
    setTimeout(()=>document.getElementById('#login_btn').click(),1000)
}
window.openOperation = () => {
    document.getElementById('login_id').value='operation'
    document.getElementById('password').value='33333333'
    setTimeout(()=>document.getElementById('#login_btn').click(),1000)
}
window.openViewerRecept = () => {
    document.getElementById('login_id').value='viewer_recept'
    document.getElementById('password').value='55555555'
    setTimeout(()=>document.getElementById('login_btn').click(),1000)
}
window.openViewer = () => {
    document.getElementById('login_id').value='viewer'
    document.getElementById('password').value='44444444'
    setTimeout(()=>document.getElementById('login_btn').click(),1000)
}

